import React from 'react'
import { Section } from '../../../../components/section'
import { HCard } from '../card'
import { H2 } from '../../../../components/typography'
import { SecondaryText, SectionTitle } from '../atom'
import styled from 'styled-components'

const WrapFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`
export interface StatusProps {
  menuData: any
  title?: string
}

export function Status(props: StatusProps) {
  const { menuData, title } = props
  return (
    <Section>
      <SectionTitle>{title ? title : '行业现状'}</SectionTitle>
      <WrapFlex>
        {menuData.map((item: any) => (
          <HCard icon={item.icon} imgMargin='0px 1.7em 0px 1.3em'>
            <H2>{item.title}</H2>
            <SecondaryText>{item.description}</SecondaryText>
          </HCard>
        ))}
      </WrapFlex>
    </Section>
  )
}
